// extracted by mini-css-extract-plugin
export var headerCell = "_18-1";
export var loadingSpinnerContainer = "_18-4";
export var loadingStateCell = "_18-5";
export var rowWrapper = "_18-3";
export var standaloneTable = "_18-6";
export var table = "_18-0";
export var white = "_18-2";